export default __webpack_public_path__ + "static/media/scene_2.9aa95c51.png";